import { infer as Infer, z } from 'zod';

import { locationCreateSchema } from './locationCreate.schema';

export const locationEditSchema = locationCreateSchema.extend({
  id: z.number(),
});

export type LocationEditSchema = Infer<typeof locationEditSchema>;
